import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import { ContentHeader, Loader } from '@components';
import { useFormik } from 'formik';
import { toast } from 'react-toastify';
import { getUserById, getPermissionList, updateUserPermissionData } from '../../services/users';
import { getPortalById } from '../../services/portal';

const ManagePermission = () => {
  const [isLoading, setLoading] = useState(false);
  const [permissions, setPermissions] = useState([]);
  const [selectPermissionId, setselectPermissionId] = useState([]);
  const [siteName, setSiteName] = useState('');
  const [uncheckPermissions, setUncheckPermissions] = useState([]);
  const [fillData, setFillData] = useState({
    name: '',
    email: ''
  });
  const navigate = useNavigate();
  const params = useParams();


  useEffect(() => {
    if (typeof params.user_id !== "undefined") {
      getPermission(params.portal_id);
      getUser(params.user_id);
      getPortalDetail(params.portal_id);
    }
  }, [])

  const handleSelect = (event: any) => {
    var value1 = event.target.value;
    var updatedList = [...selectPermissionId];
    if (event.target.checked) {
      updatedList.push(parseInt(value1));
      setselectPermissionId(updatedList);
    } else {
      const index = updatedList.indexOf(parseInt(value1));
      if (index > -1) {
        updatedList.splice(index, 1);
      }
      setselectPermissionId(updatedList);
    }
  };

  const getPermission = (portal_id: number) => {
    setLoading(true);
    getPermissionList(portal_id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.permissionsData;
        setPermissions(respData);
      } else {
        navigate("/users");
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefined' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  };

  const getUser = (id: any) => {
    setLoading(true);
    getUserById(id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.user;
        setFillData({
          name: respData.name,
          email: respData.email
        });
        setselectPermissionId(respData.permissions);
      } else {
        navigate("/users");
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefined' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  };

  const getPortalDetail = (id: any) => {
    setLoading(true);
    getPortalById(id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.record;
        setSiteName(respData.name);
      } else {
        navigate("/users");
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefined' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  };

  const updateUserPermission = (id: any, values: any) => {
    setLoading(true);
    updateUserPermissionData(id, {
      "permissions": values,
      "uncheck_permission": getUncheckData()
    }).then(function (res) {
      const resp = res.data;
      setLoading(false);
      if (resp.Acknowledge == 1) {
        toast.success('Permissions updated Successfully!');
      } else {
        toast.error(resp.FullMessage !== 'undefined' ? resp.FullMessage : 'Validation error found!');
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!');
    });
  };

  const checkAll = (e) => {
    let perids = [];
    if (e.target.checked) {
      Object.keys(permissions).map((key) => {
        permissions[key].map((row) => {
          perids.push(row.id);
        })
        setselectPermissionId(perids);
      })
    } else {
      setselectPermissionId(perids);
    }
  }

  const getUncheckData = () => {
    let perids: any = [];
    Object.keys(permissions).map((key: any) => {
      permissions[key].map((row: any) => {
        if (!selectPermissionId.includes(row.id)) {
          perids.push(row.id);
        }
      })
    })
    return perids;
  }

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: fillData,
    enableReinitialize: true,
    onSubmit: (values) => {
      if (typeof params.user_id !== "undefined") {
        updateUserPermission(params.user_id, selectPermissionId);
      }
    }
  });

  return (
    <>
      <ContentHeader title={`Manage Permission for ${siteName}`} />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <h5 className='mb-3 row'>
                  <div className="col-md-6">
                    User - {fillData.email}
                  </div>
                  {Object.keys(permissions).length > 0 &&
                    <div className="form-group col-md-6">
                      <div className="custom-control custom-switch text-right">
                        <input type="checkbox"
                          className="custom-control-input"
                          name='checkall'
                          id='checkall'
                          value='1'
                          onChange={(e) => checkAll(e)}
                        />
                        <label className="custom-control-label" htmlFor={`checkall`}>Check/Uncheck All</label>
                      </div>
                    </div>
                  }
                </h5>

                <div className='row'>

                  <div className="col-12">
                    {Object.keys(permissions).map((key) => (
                      <>
                        <div className="card card-secondary">
                          <div className="card-header">
                            <h3 className="card-title">{key}</h3>
                          </div>
                          <div className="card-body pb-0" >
                            <div className="row">
                              {permissions[key].map((row) => (
                                <>
                                  <div className="form-group col-md-3">
                                    <div className="custom-control custom-switch">
                                      <input type="checkbox"
                                        className="custom-control-input"
                                        id={`permissionSwitch_${row.id}`}
                                        name={`permission_${row.id}`}
                                        value={row.id}
                                        checked={selectPermissionId.includes(row.id) ? true : false}
                                        onChange={(e) => handleSelect(e)}
                                      />
                                      <label className="custom-control-label" htmlFor={`permissionSwitch_${row.id}`}>{row.name.toUpperCase()}</label>
                                    </div>
                                  </div>
                                </>
                              ))}
                            </div>
                          </div>
                        </div>
                      </>
                    ))}
                    {Object.keys(permissions).length == 0 ? 'No Permissions for this site' : ''}
                  </div>

                  {!isLoading &&
                    <div className="col-12">
                      <div className="form-group btn_wrap mt-4">
                        {Object.keys(permissions).length > 0 &&
                          <button type="submit" className="btn btn-primary red_btn">Update Permission</button>
                        }
                        <Link to={`/users/manage-sites/${params.user_id}`} className="btn btn-primary red_outline_btn">Back</Link>
                      </div>
                    </div>
                  }
                </div>
              </form>
            </div>
            <Loader isLoading={isLoading} />
          </div>
        </div>
      </section>
    </>
  )

};

export default ManagePermission;